export default {
  name: 'accountMenu',
  component() {
    return {
      isOpen: false,
      currentUrl: window.location.href,
      currentPath: window.location.pathname,
      currentSearch: window.location.search,

      init() {
        // Update active title after component is initialized
        this.$nextTick(() => {
          const activeTitle = this.getActiveTitle();
          if (activeTitle !== 'Account Menu' && this.$refs.activeTitle) {
            this.$refs.activeTitle.textContent = activeTitle;
          }
        });
      },

      isActiveLink(linkUrl) {
        // Remove any trailing slashes for consistent comparison
        const normalizedCurrent = this.currentUrl.replace(/\/$/, '');
        const normalizedLink = linkUrl.replace(/\/$/, '');

        // Direct URL match (exact match including query parameters)
        if (normalizedCurrent === normalizedLink) {
          return true;
        }

        // If current URL has query parameters, only match links with exact query parameters
        if (this.currentSearch) {
          // Check if link contains query parameters
          if (linkUrl.includes('?')) {
            const [linkPath, linkParams] = linkUrl.split('?');
            const currentParams = this.currentSearch.substring(1); // Remove the '?'
            
            // Check if paths match and query parameters match exactly
            if (this.currentPath === linkPath && currentParams === linkParams) {
              return true;
            }
          }
          
          // If current URL has query params but link doesn't, it's not active
          // This prevents /account from being active when on /account?view=orders
          return false;
        }

        // If current URL has no query parameters, check for path-only matches
        // But exclude links that have query parameters
        if (!linkUrl.includes('?')) {
          // Path-only comparison for account routes
          if (linkUrl.includes('account') && this.currentPath.includes('account')) {
            return this.currentPath === linkUrl || this.currentUrl === linkUrl;
          }
        }

        return false;
      },

      getActiveTitle() {
        // Find links within the current component scope
        const links = Array.from(this.$el.querySelectorAll('[class*="account-menu__link--"]'));
        const activeLink = links.find((link) => this.isActiveLink(link.href));
        return activeLink ? activeLink.textContent.trim() : 'Account Menu';
      },

      toggleDropdown() {
        this.isOpen = !this.isOpen;
      },

      closeDropdown() {
        this.isOpen = false;
      }
    };
  }
};
